import { SupportedEnvironments } from '@/config/environments';

export function getGatewayEndpoint(environment: SupportedEnvironments) {
  switch (environment) {
    case SupportedEnvironments.DEV:
      return 'https://video-api.dev.naluri.net';
    case SupportedEnvironments.SIT:
      return 'https://video-api.staging.naluri.net';
    case SupportedEnvironments.PROD:
      return 'https://video-api.naluri.net';
    default:
      throw new Error(`Environment ${environment} is not supported.`);
  }
}
